import React, { type ReactElement } from 'react';
import Alert from 'atom-components/alert';

export function systemError(message: string): string {
  return `System Error: ${message} Please contact NZCER.`;
}

export default function SystemErrorAlert({ children }: { children: string }): ReactElement {
  return <Alert variant="danger">{systemError(children)}</Alert>;
}
